import React, { useEffect, useLayoutEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { TStyle, useClassnames, useDesignTokensNative } from '@wb-tech/ui-react';
import * as Sentry from '@sentry/react';

import { useDispatch } from '#core/store';
import { useRouteMatch } from '#hook/use-route-match';
import { usePrevious } from '#hook/use-previous';

import { ErrorFallback } from '#component/error-fallback';
import { Header } from '#component/header';
import { OfferModal } from '#component/offer-modal';
import { sliderMenu } from '#component/slider/slice';
import { BannerMessage } from '#component/banner-message';
import { Quiz } from '#component/quiz';

import style from './index.module.pcss';

export interface IProps {
    className?: TStyle | string
}

export const Layout = (props: IProps) => {
    const cn = useClassnames(style, props.className);

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const { match } = useRouteMatch();
    const previousPathname = usePrevious(location.pathname);

    // Scroll to top if path changes
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useDesignTokensNative(document.body);

    useEffect(() => {
        if(match.root || match.campaigns.root) {
            navigate('/campaigns/list', { replace: true });
        }
    }, [match.campaigns.root, match.root, navigate]);

    useEffect(() => {
        if(location.pathname !== previousPathname) {
            dispatch(sliderMenu.actions.reset());
        }
    }, [dispatch, location.pathname, previousPathname]);

    return (
        <Sentry.ErrorBoundary
            fallback={(payload) => (
                <ErrorFallback {...payload} />
            )}
        >
            <div
                className={cn('layout', {
                    'layout__promotions': match.campaigns.promotions !== null
                })}
            >
                <Header />
                {/* временно не отображаем баннеры в разделе "Мои бонусы" https://youtrack.wildberries.ru/issue/AP-9196 */}
                <BannerMessage />
                <OfferModal />
                <div
                    className={cn('layout__inner', {
                        'layout__inner-edit'       : match.campaigns.edit !== null,
                        'layout__inner-list'       : (match.campaigns.list || match.campaigns.statistics || match.campaigns.statisticsDetails) !== null,
                        'layout__inner-create-auto': match.campaigns.createAuto !== null,
                        'layout__inner-promotions' : match.campaigns.promotions !== null,
                        'layout__inner-dialog'     : match.dialog.details !== null,
                        'layout__inner-dialogs'    : match.dialog.list !== null
                    })}
                >
                    <Outlet />
                </div>
            </div>
            <Quiz />
        </Sentry.ErrorBoundary>
    );
};
